<template>
    <div class="ExchangeSucess">
        <!-- <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        >   
        </van-list> -->
            <div class="code-img">
                <img :src="base_url" alt="">
            </div>
            <!-- <div class="ExchangeSucess-top">
                
                <img src="@/assets/img/goods/sucess.png" alt="">
            </div> -->
            <div class="ExchangeSucess-notice">
                <div class="title">温馨提示：</div>
                <div class="content">
                    请长按识别二维码，关注【多卡快递】公众号，订单发货后会通过该公众号实时推送快递动态信息。
                </div>
            </div>
            <div class="ExchangeSucess-goods" v-if="false">
                <div class="goods-titel">
                    <img src="@/assets/img/goods/fire.png" alt="">
                    <span>精品推荐</span>
                </div>
                <div class="good-list" >
                    <good  v-for="item in goodsList" :key="item.id" :goodItem='item' />
                </div>
            </div>
        
    </div>
</template>
<script>
import good from  '@components/goods/good'
export default {
    components:{
        good
    },
    data(){
        return{
              goodsList:[
                {name:'新货 野生核桃仁158g果炒货 果仁 山核桃仁',price1:'50',price2:'25',id:1,img:require('@/assets/img/carefullyChosen/goods.png')},
                {name:'新货 野生核桃仁158g果炒货 果仁 山核桃仁',price1:'50',price2:'25',id:2,img:require('@/assets/img/carefullyChosen/goods.png')},
                {name:'新货 野生核桃仁158g果炒货 果仁 山核桃仁',price1:'50',price2:'25',id:3,img:require('@/assets/img/carefullyChosen/goods.png')},
                {name:'新货 野生核桃仁158g果炒货 果仁 山核桃仁',price1:'50',price2:'25',id:4,img:require('@/assets/img/carefullyChosen/goods.png')},
                {name:'新货 野生核桃仁158g果炒货 果仁 山核桃仁',price1:'50',price2:'25',id:5,img:require('@/assets/img/carefullyChosen/goods.png')},
            ],
            loading: false,
            finished: true,
            base_url:""
        }
    },
    created(){
        this.base_url = JSON.parse(window.sessionStorage.getItem("SUCESSDATA")).url
    },
    methods:{
          onLoad() {
              this.error = true;
         },
    }
}
</script>
<style lang="scss" scoped>
    .ExchangeSucess{
        background: #F9F9F9;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 60%;
        background: #fff;
        .code-img{
            width: 100%;
            text-align: center;
            background: #fff;
            // border-top: 6px solid #F9F9F9;
            img{
                width: 300px;
                height: 300px;
            }

        }
        .ExchangeSucess-top{
            width: 100%;
            height: 120px;
            border-bottom: 10px solid #F9F9F9;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;
            img{
                width: 243px;
                height: 61px;
            }
        }
        .ExchangeSucess-notice{
            padding: 27px 27px 37px 41px;
            background: #fff;
            .title{
                width: 100%;
                text-align: center;
                font-size:30px;
                font-family:PingFang SC;
                font-weight:500;
                color:rgba(102,102,102,1);
            }
            .content{
                font-size:28px;
                font-family:PingFang SC;
                font-weight:400;
                color:rgba(102,102,102,1);
                line-height:40px;
                margin-top: 30px;
            }

        }
        .ExchangeSucess-goods{
            padding:30px 24px ;
            .goods-titel{
                display: flex;
                align-items: center;
                img{
                    width: 28px;
                    height: 35px;
                }
                span{
                    font-size:32px;
                    font-family:PingFang SC;
                    font-weight:500;
                    color:rgba(68,68,68,1);
                }
            }
            .good-list{
                padding:33px 0;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
            }
        }
    }
</style>